// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RegexEntityConfig__container___30cxK{display:flex}.RegexEntityConfig__left___20iqs{flex:1;padding-right:35px;border-right:1px solid #c2c2c2}.RegexEntityConfig__right___25Wwr{flex:1;padding-left:35px}.RegexEntityConfig__header___2absx{font-weight:500;font-size:16px}.RegexEntityConfig__row___YWMYi{font-size:14px;margin-bottom:12px}.RegexEntityConfig__key___4zK62{font-weight:500}.RegexEntityConfig__matchingText___3Lm0y{background-color:yellow}.RegexEntityConfig__sampleRegex___2fXBw{font-weight:500}\n", ""]);
// Exports
exports.locals = {
	"container": "RegexEntityConfig__container___30cxK",
	"left": "RegexEntityConfig__left___20iqs",
	"right": "RegexEntityConfig__right___25Wwr",
	"header": "RegexEntityConfig__header___2absx",
	"row": "RegexEntityConfig__row___YWMYi",
	"key": "RegexEntityConfig__key___4zK62",
	"matchingText": "RegexEntityConfig__matchingText___3Lm0y",
	"sampleRegex": "RegexEntityConfig__sampleRegex___2fXBw"
};
module.exports = exports;
